import { Model } from 'dva'

const initialState = {
  presenterMode: false,
}

const Build: Model = {
  namespace: 'build',
  state: initialState,
  effects: {},
  reducers: {
    setState(state, action) {
      return {
        ...state,
        ...action.payload,
      }
    },
    resetBuild(state, action) {
      return {
        ...state,
        ...initialState,
      }
    },
  },
}

export default Build
